import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 66.167 66.167',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M41.083,8A33.083,33.083,0,1,0,74.167,41.083,33.078,33.078,0,0,0,41.083,8Zm0,61.9A28.815,28.815,0,1,1,69.9,41.083,28.813,28.813,0,0,1,41.083,69.9ZM53.73,31.839l-9.245,9.245,9.245,9.245a1.6,1.6,0,0,1,0,2.268L52.6,53.73a1.6,1.6,0,0,1-2.268,0l-9.245-9.245L31.839,53.73a1.6,1.6,0,0,1-2.268,0L28.437,52.6a1.6,1.6,0,0,1,0-2.268l9.245-9.245-9.245-9.245a1.6,1.6,0,0,1,0-2.268l1.134-1.134a1.6,1.6,0,0,1,2.268,0l9.245,9.245,9.245-9.245a1.6,1.6,0,0,1,2.268,0l1.134,1.134a1.627,1.627,0,0,1,0,2.268Z"
          transform="translate(-8 -8)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
